import Swal from "sweetalert2";

const loginForm = document.getElementById("loginForm");

export default function checkPassword() {
	if (!loginForm) {
		return;
	}

	loginForm.addEventListener("submit", (evt) => {
		const password = document.getElementById("password").value;
		if (
			password.length < Number.parseInt(loginForm.dataset.passwordminlength, 10)
		) {
			evt.preventDefault();

			Swal.fire(
				"Passwortsicherheit",
				"Das von Ihnen verwendete Passwort ist sehr unsicher. Bitte ändern Sie dieses in Ihrem Profil zu Ihrer eigenen Sicherheit!",
				"warning",
			).then(() => loginForm.submit());
		}
	});
}
